import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@airia/ui';
import { useAddinChatActions } from '../AddinChatActionsContext';
import { MessageButtonSchema } from './schemas';
/**
 * Renders `<airiaMessageButton buttonText="...">message body</airiaMessageButton>`
 * as a single button that submits the body text as the user's next message.
 */
export function MessageButton(props) {
    const { children, artifactContent, buttonText } = MessageButtonSchema.parse(props);
    const actions = useAddinChatActions();
    const messageContent = artifactContent || children;
    if (!messageContent)
        return null;
    const handleClick = () => {
        if (!actions || actions.isExecuting)
            return;
        void actions.submitMessage(messageContent);
    };
    return (_jsx(Button, { size: "sm", variant: "outline", onClick: handleClick, disabled: !actions || actions.isExecuting, children: buttonText.length > 0 ? buttonText : messageContent }));
}
